var _ = require('underscore');
var Section = require('submissions/pages/Section/Section');

require('./Submissions.less');

var Banner = require('submissions/components/Banner/Banner');

var DraftDelete = require('submissions/components/DraftDelete/DraftDelete');

module.exports = Section.extend({

    el: '.Submissions',

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'Banner': {selector: '.Banner', viewConstructor: Banner},
        'DraftDelete': {selector: '.DraftDelete', viewConstructor: DraftDelete}
    },


    events: {
        'click .Submissions-itemControlsDelete': 'onDeleteClick'
    },


    initialize: function (options) {
        this.options = options || {};

        if (window.localStorage) {
            if (localStorage.getItem('submitted')) {
                this.$('.Submissions-manage-submittedMessage')
                    .show()
                    .find('b')
                    .text(localStorage.getItem('submitted'));

                var contributorsStr = localStorage.getItem('submittedContributors');

                if (contributorsStr) {
                    var contributors = JSON.parse(contributorsStr);

                    if (contributors.length) {
                        if (contributors.length > 1) {
                            var emails = '<br>An e-mail has been also sent to:<br>' + contributors.join('<br>');
                        } else {
                            var emails = '<br>An e-mail has been also sent to ' + contributors[0];
                        }
                        this.$('.Submissions-manage-submittedMessage span').html(emails);
                    }
                }

                localStorage.removeItem('submitted');
                localStorage.removeItem('submittedContributors');
            }
        }

        Section.prototype.initialize.call(this, options);
    },


    viewsRegistration: function () {
        Section.prototype.viewsRegistration.call(this);

        this.draftDelete = this.getView('DraftDelete');
    },


    onDeleteClick: function (e) {
        var $item = $(e.currentTarget);
        var id = $item.attr('data-id');
        var kind = $item.attr('data-kind');

        this.draftDelete && this.draftDelete.show({
            cb: function (confirmed) {
                if (confirmed) {

                    this.deleteXhr && this.deleteXhr.abort();

                    this.deleteXhr = $.ajax({
                        url: Urls['submissions:api:submission'](kind, id, 'json'),
                        method: 'DELETE',
                        contentType: 'application/json; charset=utf-8',
                        dataType: 'json',
                        success: function (responseData) {
                            window.location.href = Urls['submissions:submissions']();
                        },
                        error: function (e, tp) {
                            if (tp != 'abort') {
                                alert('Error ' + e.status + ': ' + e.statusText);
                            }

                            console.log('error', arguments);
                        },
                        context: this
                    });

                }
            }.bind(this)
        });
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/pages/Submissions/Submissions.js
// module id = 137
// module chunks = 0